var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "auto",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72919 1.83334C4.59023 1.83334 3.66669 2.75688 3.66669 3.89584V18.1042C3.66669 19.2431 4.59023 20.1667 5.72919 20.1667H16.2709C17.4098 20.1667 18.3334 19.2431 18.3334 18.1042V9.16667H13.0625C11.9236 9.16667 11 8.24313 11 7.10417V1.83334H5.72919ZM12.375 2.23617V7.10417C12.375 7.48321 12.6835 7.79167 13.0625 7.79167H17.9305L12.375 2.23617ZM14.6667 11.4583C15.1731 11.4583 15.5834 11.8685 15.5834 12.375C15.5834 12.8599 15.2051 13.2533 14.7285 13.2854L12.8271 15.1868C12.7945 15.6639 12.4016 16.0417 11.9167 16.0417C11.4318 16.0417 11.0384 15.6634 11.0063 15.1868L9.62502 13.8055L8.24375 15.1868C8.21167 15.6634 7.81827 16.0417 7.33335 16.0417C6.8269 16.0417 6.41669 15.631 6.41669 15.125C6.41669 14.6401 6.79492 14.2467 7.27159 14.2146L8.71462 12.7716C8.74716 12.2944 9.1401 11.9167 9.62502 11.9167C10.1099 11.9167 10.5033 12.2949 10.5354 12.7716L11.9167 14.1528L13.7563 12.3132C13.7884 11.8366 14.1818 11.4583 14.6667 11.4583Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.98db2916ad976c68bf598f62a6feba97.svg";
export { ForwardRef as ReactComponent };